const PATH = {
	HOME: "/",
	BID: "/bid",
	RESULT: "/result",
	RULE: "/rule",
	PLAYGROUND: "/playground",
	ACCOUNT: "/account",
	LOGIN: "/login",
	PACKAGE_HISTORY: "/account/package-history",
	PACKAGE: "/account/package",
	AUCTION_RECORD: "/account/auction-record",
	CHANGE_PASSWORD: "/account/change-password",
	EVENT: "/event",
	EVENT_NEW_YEAR_CHRISTMAS: "/event-new-year-christmas",
	PACKAGE_DAILY: "/account/package-daily",
	PACKAGE_WEEKLY: "/account/package-weekly",
	PACKAGE_MONTHLY: "/account/package-monthly",
	PACKAGE_SUB: "/account/package-sub",
	EVENT_THINGYAN: "/event-thingyan",
	MINI_GAME: "/mini-game",
	HISTORY: "/history",
	SHWE_JOURNEY: "/shwe-journey",
	SHWE_VAULT: "/shwe-vault",
	NOTIFICATION: "/notification",
	PRIZE_POOL: "/prize-pool",
  DAILY_REWARD: "/daily-reward",
  HELP_CENTER: "/help-center",
  RANK: "/rank",
  LOYALTY_POINT: "/loyalty-point",
};
export default PATH;
